<template>
	
<core-list-row class="list-row">

	<template v-slot:fields>

		<core-list-cell type="avatar" :format="{}">

			<core-avatar :item="item" type="user" :id="item.id" class="user-avatar" />

		</core-list-cell>

		<core-list-cell type="name" :format="{filter: 'users', sort: 'name'}" class="user-name">

			<div>

				<app-router :to="{name: 'Collection', params: {type: 'users', name: item.name}}" class="user-name">{{ name }}</app-router>

				<div class="user-name-username" v-if="item.fullname">@{{ item.name }}</div>

			</div>

			<div class="context-icons-wrapper">

				<div class="context-icons">

					<i class="fa-solid fa-user context-boost is-dark" v-tooltip="'Registered since ' + registered" v-if="registered && !patreon" />
					<i class="fa-solid fa-gift context-boost is-green" v-tooltip="'Daily group syncing gifted by ' + dailyperk.join(', ')" v-if="dailyperk" />
					<i class="fa-brands fa-patreon context-boost is-dark" v-tooltip="'Patreon since ' + patreon.year" v-if="patreon" />
					<i class="fa-solid fa-rocket-launch context-boost is-orange" v-tooltip="'Speed boosted'" v-if="boosted" />
					<core-flag :id="country" class="context-boost" v-tooltip="countryName" />

				</div>

			</div>

		</core-list-cell>

		<core-list-cell type="stat" v-if="!window.is.mobile" :format="{filter: 'users', sort: 'collection'}">

			{{ item.count.collection }}

		</core-list-cell>

		<core-list-cell type="stat" v-if="!window.is.mobile" :format="{filter: 'users', sort: 'ratings'}">

			{{ item.count.ratings }}

		</core-list-cell>

		<core-list-cell type="stat" v-if="!window.is.mobile" :format="{filter: 'users', sort: 'plays'}">

			{{ item.count.plays }}

		</core-list-cell>

		<core-list-cell type="stat" v-if="!window.is.mobile" :format="{filter: 'users', sort: 'hindex'}">

			{{ item.hindex.value }}

		</core-list-cell>

		<core-list-cell-actions v-if="isGroup" :item="item" filter="users" />

	</template>

</core-list-row>

</template>

<script>

export default {

	props: ['item'],

	computed: {

        patreon: function() {

            return this.item.patreon

        },

        boosted: function() {

            return this.item.boosted

        },

		dailyperk: function() {

			return this.item.dailyperk

		},

		registered: function() {

			return this.$filter('formatDate', this.item.date.registered, 'YYYY')

		},

		hasActions: function() {

			return this.$store.getters['permissions/is/owner'] && this.$store.getters['context/is/group']

		},

		country: function() {

			return this.item.country

		},

		countryName: function() {

			return this.$CONSTANTS.COUNTRY[this.item.country]

		},

		name: function() {

			return this.item.fullname || this.item.name

		},

		canRemove: function() {

			return this.item.id !== this.$store.getters['session/user/id'] && this.$store.getters['permissions/group/remove']

		}
		
	},

	methods: {

		onRemoveClick: function(id) {

			this.$pubsub.$emit('open.modal', {
				id: 'groupRemove',
				user: id
			})

			this.$pubsub.$emit('dropdown.action')
			
		}

	}

}

</script>

<style scoped>

.user {
	width: 100%;
	padding: 0px 7px;
	border-bottom: 1px solid #eee;
}

.user-columns {
	width: 100%;
	display: flex;
	justify-content: flex-start;
	height: 63px;
	padding-bottom: 8px;
	padding-top: 7px;
}

.is-desktop .user:hover {
	background-color: #e9f3f7;
}

.user-column {
	height: 48px;
}

.user-avatar {
	width: 48px;
	min-width: 48px;
	height: 48px;
	border-radius: 24px;
	font-size: 24px;
}

.user-avatar-flag {
	position: absolute;
	width: 12px;
	height: 12px;
	background-position: 50% 50%;
	background-size: 16px 16px;
	border-radius: 6px;
	bottom: 0px;
	right: 0px;
}

.user:last-child {
	border-bottom: 0px;
	margin-bottom: 0px;
}

.user-name {
	overflow: hidden;
	min-width: 0;
	display: block;
	max-width: 100%;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 16px;
	line-height: 16px;
	cursor: pointer;
	overflow: hidden;
	color: #333;
	font-weight: 500;
}

.is-desktop .user-name:hover {
	text-decoration: underline;
}

@media only screen and (max-width: 767px) {

	.user-name :hover { 
		font-size: 14px;
	}

}

.user-name-username {
	font-size: 12px;
	font-weigt: 400;
	color: #666;
	line-height: 12px;
	margin-top: 2px;
}

.context-icons-wrapper {
    flex-shrink: 0;
    height: 32px;
}

.is-mobile .context-icons-wrapper {
    width: 48px;
	height: 24px;
}

.context-icons {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 0px;
    top: 0px;
}

.context-boost {
    border-radius: 50%;
    width: 32px;
    font-size: 16px;
    position: relative;
    height: 32px;
    text-align: center;
    line-height: 32px;
    margin-left: 4px;
    z-index: 10;
    transition: all 100ms ease-in-out;
}

.is-mobile .context-boost {
	width: 24px;
	height: 24px;
	line-height: 24px;
	font-size: 14px;
}

.is-mobile .context-boost {
	margin-left: 2px;
}

.context-boost.is-dark {
    color: #fff;
    background-color: #4881bb;
}

.context-boost.is-orange {
    color: #082534;
    background-color: #ffc563;
}

.context-boost.is-green {
    color: #fff;
    background-color: #34a66e;
}

.is-mobile .context-boost:nth-child(2) {
    z-index: 9;
    margin-left: -12px;
}

.is-mobile .context-boost:nth-child(3) {
    z-index: 8;
    margin-left: -12px;
}

.is-mobile .context-icons:hover .context-boost:nth-child(2),
.is-mobile .context-icons:hover .context-boost:nth-child(3) {
    margin-left: 2px;
}

.user-name >>> .cell-subwrapper {
	display: grid;
    grid-template-columns: 1fr auto;
	align-items: center;
}

</style>
